<template>
  <div class="ma-5">
    <v-alert class="round" outlined type="info" color="accent" text>
      <!-- <p>LenderVeiw: {{ this.lenderView }}</p>
      <p>BorrowerView: {{ this.borrowerView }}</p> -->
      <p
        class="mb-n1"
        v-if="booking.status == 'pending' && lenderView == true"
        v-text="
          booking.borrowerName +
          ' has requested to book your item. You can choose to accept or decline this request.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'pending' && borrowerView == true"
        v-text="
          ' You have requested to book this item. If ' +
          booking.lenderName +
          ' accepts this request you will be prompted to make a payment.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'declined'"
        v-text="'Unfortunately this booking has been declined.'"
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'awaiting-payment' && borrowerView == true"
        v-text="
          booking.lenderName +
          ' has approved your booking request and is waiting for payment. You can make the payment by clicking the Pay button.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'awaiting-payment' && lenderView == true"
        v-text="
          'You have approved this booking. Awaiting payment from ' +
          booking.borrowerName +
          '.'
        "
      />

      <p
        class="mb-n1"
        v-if="
          (booking.status == 'finalised' && borrowerView == true) ||
          (booking.status == 'awaiting-images' && borrowerView == true)
        "
        v-text="
          'The booking has been paid for. Please ensure you check the condition of the item when you receive it. You have a money back guarantee within 24 hours of collection if you don\'t receive what\'s promised.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'finalised' && lenderView == true"
        v-text="
          'This booking has been paid for, please ensure the item is in working condition and as described before handover.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'awaiting-images' && lenderView == true"
        v-text="
          booking.borrowerName +
          ' has accepted your booking. Remember to upload your Quality assurance images before handing the item over.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'pending-return' && lenderView == true"
        v-text="
          'This booking has ended. Once ' +
          booking.borrowerName +
          ' has returned your item please use the button below to confirm. If there are any issues please log a ticket with our helpdesk.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'pending-return' && borrowerView == true"
        v-text="
          'Your rental period with ' +
          booking.lenderName +
          ' has expired. If you have not yet returned the item, please do so. Once ' +
          booking.lenderName +
          ' has confirmed the return you may follow the steps to receive your deposit back.'
        "
      />

      <p
        class="mb-n1"
        v-if="
          booking.status == 'returned' ||
          booking.status == 'returnedL' ||
          booking.status == 'returnedB'
        "
        v-text="
          booking.borrowerName +
          ' has returned your item. Leave a review to complete this booking.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'complete'"
        v-text="'This booking hase been completed 😊'"
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'cancelled'"
        v-text="'Unfortunately this booking has been cancelled.'"
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'overdue'"
        v-text="'This booking is overdue.'"
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'active' && lenderView == true"
        v-text="
          booking.borrowerName + ' is currently renting this item from you.'
        "
      />

      <p
        class="mb-n1"
        v-if="booking.status == 'active' && this.borrowerView == true"
        v-text="
          'You are currently renting this item from ' +
          booking.lenderName +
          '. If you have a problem with the item please log a ticket with our helpdesk.'
        "
      />
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "StrappStatusBox",

  props: {
    booking: {
      type: Object,
      required: true,
    },
    lenderView: {
      type: Boolean,
      required: true,
    },
    borrowerView: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
